import React, {useEffect, useState} from 'react'
import {useRequest} from "ahooks";
import {FormSelect} from "../../FormSelect";
import CurvatureOffCanvas from "./CurvatureOffCanvas";
import curvatureService from "../../../../../services/curvatureService";
import {useFormikContext} from "formik";
import CanvasCreateEditButtons from "../../../UI/Canvas/CanvasCreateEditButtons";
import {toast} from "react-toastify";

const CurvaturePicker = ({name, onSelected, withCreate}) => {

    const {data, loading, runAsync} = useRequest(curvatureService.selectable);

    const [currentSelected, setCurrentSelected] = useState(undefined);
    const {values, setFieldValue} = useFormikContext()
    const [isCanvasOpen, setIsCanvasOpen] = useState(false);

    useEffect(() => {
        if (loading)
            return;

        if (values[name]) {
            const option = data.find(d => d.value === values[name])
            option
                ? curvatureService.fetch(option.uuid).then(res => setCurrentSelected(res))
                : setCurrentSelected(undefined)
        } else {
            setCurrentSelected(undefined)
        }

    }, [data, values[name]])

    const handleResponse = (value) => {
        runAsync().then(() => {
            onSelected({
                value: value.id,
                label: value.name
            })
            setIsCanvasOpen(false)
        })
    }

    const handleDelete = () => {
        curvatureService.destroy(currentSelected.uuid)
            .then(res => runAsync()
                .then(() => {
                    setFieldValue(name, undefined)
                    toast.success('Operazione eseguita con successo')
                })
            ).catch(err => toast.error(err.response.data.message))
    }


    return (
        <React.Fragment>

            <FormSelect
                name={name}
                onChange={(curvature) => onSelected(data.find(d => d.value === curvature))}
                loading={loading}
                placeholder="Seleziona uno curvatura"
                options={data}
                multiple={false}
            />

            {withCreate &&
                <>
                    <CanvasCreateEditButtons
                        value={values[name]}
                        canvasOpen={isCanvasOpen}
                        setCanvasOpen={setIsCanvasOpen}
                        handleDelete={handleDelete}
                    />

                    <CurvatureOffCanvas
                        isOpen={isCanvasOpen}
                        toggle={setIsCanvasOpen}
                        data={currentSelected}
                        handleResponse={handleResponse}
                    />
                </>
            }

        </React.Fragment>
    )
}

export default CurvaturePicker